export const ellipseTokenId = (tokenId: string) => {
  if (tokenId.length > 10) {
    return [tokenId.slice(0, 3), "...", tokenId.slice(-5)].join("");
  } else {
    return tokenId;
  }
};
